import type { FC } from 'react'
import { Alert, Button, SpaceBetween } from '@cloudscape-design/components'

interface RequestErrorProps {
	error: unknown
	retry?: () => void
}

export const getMongoDBErrorMessage = (error: unknown) =>
	error instanceof Error ? error.message : 'Unable to complete this request.'

const RequestError: FC<RequestErrorProps> = ({ error, retry }) => (
	<Alert type="error" header="Unable to load MongoDB request">
		<SpaceBetween direction="vertical" size="s">
			<span>{getMongoDBErrorMessage(error)}</span>
			{retry && <Button onClick={retry}>Retry</Button>}
		</SpaceBetween>
	</Alert>
)

export default RequestError
